import React from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../../../hybrid/wrappers';
import { t } from '../../../../common/components/T';
import uikit from '../../../../project/uikit/styles';
import css from './Buyer.module.scss';
import classnames from 'classnames';
import Display from '../../../../common/components/Display';
import { generateGridStyles } from '../../components/helpers';
import { generateUniqueId } from '../../../../common/utils/utils';

const Buyer = ({ getHandlers, val, translation, gridStyles, name }) => {
    const { stylers, classes, existCl } = generateGridStyles(gridStyles, name);
    return (
        <div
            {...getHandlers(false)}
            style={stylers.wrapper}
            className={classnames(!!getHandlers(false)['onClick'] && css.cursorPointer, existCl('wrapper') || css.flexColumn)}
        >
            <div style={stylers.p} className={existCl('p') || css.buyerName}>
                {val?.name_formatted ? (
                    <div
                        className={classes.inner}
                        style={{
                            ...stylers.inner,
                            ...uikit.text,
                            ...uikit.mt1,
                            color: 'var(--darkColor)'
                        }}
                    >
                        <p className={classnames(css.text, classes.text)} style={stylers.text}>
                            {val?.name_formatted}
                        </p>
                        {`${val.username}` !== 'undefined' && `${val.username}` !== 'null' && (
                            <div style={uikit.flexRow}>
                                <div className={classnames(uikit.flexRow, uikit.alignItemsCenter, css.patronymicBlock)}>
                                    {svgSprite('user-circle-fill', {
                                        fill: 'var(--blueColor)',
                                        width: '18px',
                                        height: '18px',
                                        style: { marginRight: '8px' }
                                    })}
                                    <p
                                        key={generateUniqueId()}
                                        className={classes.login}
                                        style={{
                                            color: 'var(--darkColor)',
                                            ...stylers.login,
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {`${val.username}` !== 'undefined' &&
                                            `${val.username}` !== 'null' &&
                                            `${val.username.innerText}`}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                ) : val &&
                  ((`${val.username}` !== 'undefined' && `${val.username}` !== 'null') ||
                      (`${val.patronymic}` !== 'undefined' && `${val.patronymic}` !== 'null') ||
                      (`${val.first_name}` !== 'undefined' && `${val.first_name}` !== 'null') ||
                      (`${val.full_name}` !== 'undefined' && `${val.full_name}` !== 'null') ||
                      (`${val.last_name}` !== 'undefined' && `${val.last_name}` !== 'null')) ? (
                    <div
                        style={{
                            ...stylers.p,
                            ...uikit.text,
                            ...uikit.mt1,
                            color: 'var(--darkColor)'
                        }}
                    >
                        <p
                            className={classnames(css.text, classes.text)}
                            style={stylers.text}
                            key={`id-${Date.now().toString()}${Math.random()}${Math.random()}`}
                        >
                            {val.full_name || (
                                <Display
                                    type='fio'
                                    data={{
                                        first_name: val.first_name,
                                        last_name: val.last_name,
                                        patronymic: val.patronymic
                                    }}
                                />
                            )}
                        </p>
                        {`${val.username}` !== 'undefined' && `${val.username}` !== 'null' && (
                            <div style={uikit.flexRow}>
                                <div
                                    style={{
                                        ...uikit.flexRow,
                                        ...uikit.alignItemsCenter,
                                        ...stylers.patronymicBlock
                                    }}
                                    className={classnames(css.patronymicBlock, classes.patronymicBlock)}
                                >
                                    {svgSprite('user-circle-fill', {
                                        fill: 'var(--blueColor)',
                                        width: '18px',
                                        height: '18px',
                                        style: { marginRight: '8px' }
                                    })}
                                    <p
                                        className={classnames(css.text, classes.login)}
                                        style={stylers.login}
                                        key={`id-${Date.now().toString()}${Math.random()}${Math.random()}`}
                                    >
                                        {`${val.username}` !== 'undefined' && `${val.username}` !== 'null' && `${val.username}`}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    <p>-</p>
                )}
                {val && val.deleted ? (
                    <p key={`id-${Date.now().toString()}${Math.random()}${Math.random()}`} className={css.deleteUserLabel}>
                        {' '}
                        {t('gridDeletedUser', 'Удален', 'widget', translation, 'grid')}{' '}
                    </p>
                ) : null}
                {val?.has_filled_documents === false && (
                    <p style={!val?.last_name ? { marginTop: '4px' } : {}} className={css.documentUserLabel}>
                        {t('gridDocumentUser', 'Нет документов', 'widget', translation, 'grid')}
                    </p>
                )}
            </div>
        </div>
    );
};
Buyer.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    name: PropTypes.string,
    val: PropTypes.object
};
export default Buyer;
